import axios from "axios";
import { baseApiUrl, httpRequest, getHttpHeaders } from "../ApiUtils";


const groupApiUrl = `${baseApiUrl}/api/Group`;

export async function getGroup() {
    return await httpRequest(fetchGroup.bind(this));
}

async function fetchGroup() {
    let config = getHttpHeaders();
    return await axios.get(`${groupApiUrl}`, config);
}

export async function getGroupById(id) {
    return await httpRequest(fetchGroupById.bind(this, id));
}

async function fetchGroupById(id) {
    let config = getHttpHeaders();
    return await axios.get(`${groupApiUrl}/${id}`, config);
}

export async function getGroupByQuizId(quizId) {
    return await httpRequest(fetchGroupByQuizId.bind(this, quizId));
}

async function fetchGroupByQuizId(quizId) {
    let config = getHttpHeaders();
    return await axios.get(`${groupApiUrl}/Quiz/${quizId}`, config);
}

export async function addGroup(newGroup) {
    return await httpRequest(postGroup.bind(this, newGroup));
}

async function postGroup(newGroup) {
    let config = getHttpHeaders();
    return await axios.post(`${groupApiUrl}`, newGroup, config);
}

export async function updateGroup(updatedGroup) {
    return await httpRequest(putGroup.bind(this, updatedGroup));
}

async function putGroup(updatedGroup) {
    let config = getHttpHeaders();
    return await axios.put(`${groupApiUrl}`, updatedGroup, config);
}

export async function deleteGroup(id) {
    return await httpRequest(fetchDeleteGroup.bind(this, id));
}

async function fetchDeleteGroup(id) {
    let config = getHttpHeaders();
    return await axios.delete(`${groupApiUrl}/${id}`, config);
}

export async function updateGroupOrder(updatedGroupOrder) {
    return await httpRequest(putGroupOrder.bind(this, updatedGroupOrder));
}

async function putGroupOrder(updatedGroupOrder) {
    let config = getHttpHeaders();
    return await axios.put(`${groupApiUrl}/Order`, updatedGroupOrder, config);
}